import type { Grade } from '@baseball-near-you/prisma';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useGradeTeamMutation(teamId: number) {
  const queryClient = useQueryClient();
  const {
    mutateAsync: gradeTeam,
    isLoading: isGradingTeam,
    error: gradeTeamError,
  } = useMutation({
    mutationFn: async (data: Omit<Grade, 'id'>) => {
      const newGrade = await clients.team.addGrade({
        args: { teamId, reviewId: data.reviewId },
        payload: data,
      });
      return newGrade;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKey.Team, teamId, 'grades']);
    },
  });
  return {
    gradeTeam,
    isGradingTeam,
    gradeTeamError,
  };
}
